import React from 'react';
import { useSelector } from 'react-redux';
import { Table } from 'antd';

function VesselTable() {
    const selectedVessel = useSelector((state) => state.vessel.selectedVessel);

    // Define columns for Ant Design table
    const columns = [
        {
            title: 'Category',
            dataIndex: 'info',
            key: 'info',
        },
        {
            title: 'Current',
            dataIndex: 'current',
            key: 'current',
        },
        {
            title: 'YTD',
            dataIndex: 'ytd',
            key: 'ytd',
        },
    ];

    // Define data for the table
    const data = [
        {
            key: '1',
            info: 'EUA',
            current: selectedVessel?.eua_current < 0
                ? selectedVessel?.eua_current?.toFixed(3)
                : `\u00A0\u00A0${selectedVessel?.eua_current?.toFixed(3)}`,
            ytd: selectedVessel?.eua_ytd < 0
                ? selectedVessel?.eua_ytd?.toFixed(3)
                : `\u00A0\u00A0${selectedVessel?.eua_ytd?.toFixed(3)}`,
        },
        {
            key: '2',
            info: 'GHG (gCO₂/MJ)',
            current: selectedVessel?.ghg_current < 0
                ? selectedVessel?.ghg_current?.toFixed(3)
                : `\u00A0\u00A0${selectedVessel?.ghg_current?.toFixed(3)}`,
            ytd: selectedVessel?.ghg_ytd < 0
                ? selectedVessel?.ghg_ytd?.toFixed(3)
                : `\u00A0\u00A0${selectedVessel?.ghg_ytd?.toFixed(3)}`,
        },
        {
            key: '3',
            info: 'Compliance Balance (gCO₂eq)',
            current: selectedVessel?.cb_current < 0
                ? selectedVessel?.cb_current?.toFixed(3)
                : `\u00A0\u00A0${selectedVessel?.cb_current?.toFixed(3)}`,
            ytd: selectedVessel?.cb_ytd < 0
                ? selectedVessel?.cb_ytd?.toFixed(3)
                : `\u00A0\u00A0${selectedVessel?.cb_ytd?.toFixed(3)}`,
        },
        {
            key: '4',
            info: 'FEUM Penalty (€)',
            current: selectedVessel?.penalty_current < 0
                ? selectedVessel?.penalty_current?.toFixed(3)
                : `\u00A0\u00A0${selectedVessel?.penalty_current?.toFixed(3)}`,
            ytd: selectedVessel?.penalty_ytd < 0
                ? selectedVessel?.penalty_ytd?.toFixed(3)
                : `\u00A0\u00A0${selectedVessel?.penalty_ytd?.toFixed(3)}`,
        },
    ];
    
    

    return (
        <div className="vessel-table-overview vessel-table-cost-expo">
            <Table
                columns={columns}
                dataSource={data}
                pagination={false}
                bordered = {false}
                className="no-border-table"
            />
        </div>
    );
}

export default VesselTable;
